"use strict";

import Page from "./Register.jsx";

export const auth = false;
export const title = "i18n:register.pageTitle";
export const Component = Page;
